// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"9cc05ff1f4cbc2b26fa5","9249":"db18c51bcbb5c998965b"}[chunkId] + ".chunk.js";
};